var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCelebrity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_2793)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#171616"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12_2793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4524 22.7704C18.181 23.0859 17.9176 23.3917 17.6541 23.698C16.0128 25.6062 14.3715 27.5144 12.7307 29.4229C12.1605 30.086 11.5905 30.7492 11.023 31.4146C10.9677 31.4793 10.9134 31.5083 10.8254 31.5078C10.2678 31.5033 9.71025 31.5056 9.15266 31.5056H9C11.8747 28.1625 14.7321 24.8394 17.5914 21.5139C14.7281 17.3444 11.8717 13.1849 9 9.00297C9.06567 9.00297 9.10879 9.00297 9.15191 9.00297C11.2376 9.00297 13.3235 9.00397 15.4091 9C15.5187 9 15.5791 9.03618 15.6379 9.12193C16.4998 10.3823 17.3642 11.6413 18.2286 12.8999C19.2144 14.3356 20.2007 15.7709 21.1873 17.2061C21.2004 17.2254 21.2168 17.2423 21.2386 17.2688C21.4812 16.988 21.7184 16.7144 21.9546 16.4401C23.3882 14.7725 24.8213 13.1046 26.2547 11.4371C26.9273 10.6547 27.6006 9.87307 28.2713 9.08922C28.324 9.02751 28.3761 9.00025 28.4589 9.00074C29.0576 9.00421 29.6563 9.00273 30.289 9.00273C27.5481 12.1907 24.8241 15.3591 22.0966 18.5312C25.0642 22.8527 28.0264 27.166 31 31.4956C30.9522 31.4994 30.9187 31.5043 30.8853 31.5043C28.7788 31.5046 26.6723 31.5036 24.5661 31.508C24.4637 31.508 24.4196 31.4592 24.3725 31.3906C23.6933 30.4 23.0137 29.4095 22.334 28.4194C21.0817 26.596 19.8293 24.7725 18.577 22.9491C18.5379 22.8923 18.4982 22.8358 18.4524 22.7699V22.7704ZM11.641 10.4654C11.8026 10.6961 11.9471 10.902 12.0911 11.1082C13.8112 13.5713 15.5311 16.0349 17.2517 18.4977C18.4169 20.1655 19.5837 21.8324 20.7492 23.5C22.2646 25.6681 23.7803 27.8361 25.2929 30.0062C25.347 30.0836 25.4003 30.1121 25.4932 30.1116C26.3977 30.1083 27.3023 30.1098 28.2066 30.1096C28.2455 30.1096 28.2844 30.1051 28.3392 30.1019C28.3064 30.0531 28.2844 30.0191 28.2613 29.9859C26.8785 28.0068 25.4954 26.028 24.1131 24.0489C22.9575 22.3944 21.8031 20.739 20.6476 19.0848C19.6597 17.6707 18.6707 16.2574 17.6826 14.8436C16.6874 13.4196 15.6914 11.9959 14.6991 10.5697C14.6421 10.4877 14.5817 10.4631 14.487 10.4634C13.5824 10.4664 12.6779 10.4654 11.7734 10.4654C11.7377 10.4654 11.702 10.4654 11.6413 10.4654H11.641Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12_2793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22.5085,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCelebrity);
export default __webpack_public_path__ + "static/media/x-celebrity.c2ddf7eded119c008a3fb46e8bb344da.svg";
export { ForwardRef as ReactComponent };